<div class="gms-wrapper">
  <a tabindex="0"
     class="nav-toggle gms-container"
     (keydown.enter)="togglePopover()"
     (click)="togglePopover()">
    <div class="user-image"><i class="icon-user"></i></div>
    <div class="shrink">
      <div class="user-information">
        <div class="user-description">
          <ng-container *ngIf="userName$ | async as userName">
            <span [title]="userName"
                  class="name"> {{ userName }} </span>
          </ng-container>
        </div>
        <div class="sub-nav"><span class="icon-overflow-vert-ico"></span></div>
      </div>
    </div>
  </a>
  <div id="profile-pop-over"
       class="pop-over"
       [clickOutsideEnabled]="popOverOpen"
       (clickOutside)="hidePopOver()"
       [exclude]="'.nav-toggle'"
       [ngClass]="{ open: popOverOpen }">
    <a id="contacts-submenu-item"
       class="submenu-item"
       routerLink="/contacts"
       *ngIf="menuItemType != 'BISA'">
      <i class="icon-id-card popover-icon"
         alt="My Contacts"></i>My Contacts
    </a>
    <a id="profile-submenu-item"
       class="submenu-item"
       routerLink="/profile"
       *ngIf="menuItemType != 'BISA'">
      <i class="icon-user popover-icon"
         alt="My Profile"></i>My Profile
    </a>
    <ng-container *ngIf="isAuthenticated$ | async as isAuthenticated">
      <a *ngIf="!(isAuthenticated)"
         class="submenu-item"
         routerLink="/login">
        <i class="icon-logout popover-icon"
           alt="Login"></i>Login
      </a>
      <a *ngIf="(isAuthenticated)"
         id="logout-submenu-item"
         class="submenu-item"
         (click)="logout()"
         (keydown.enter)="logout()"
         tabindex="0">
        <i class="icon-logout popover-icon"
           alt=""></i>Logout
      </a>
    </ng-container>
  </div>
</div>